
export default {
  name: "AppModalFactor",
  methods: {
    copyValue(val) {
      navigator.clipboard.writeText(val);
    }
  }
}
